import { DialogTitle, IconButton, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import React from 'react';
import { styledBy } from '../../../utils/styles';
import Text from '../Text';


const useStyle = makeStyles((theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        color: styledBy('ascent', theme.palette.ascents),
        padding: theme.spacing(2)
    },
    title: {
        fontSize: 16,
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 600
    }
}))

const ModaTitle = ({ ascent, children, className, onClose, hideCloseButton = false, ...props }) => {

    const classes = useStyle({ ascent });

    return (
        <DialogTitle disableTypography className={clsx(classes.root, className)} {...props}>
            <Text className={classes.title} variant="h6">{children}</Text>
            {
                !hideCloseButton ?
                    <IconButton aria-label="close" className={classes.closeButton} color="inherit" onClick={onClose}>
                        <CloseIcon />
                    </IconButton> : null
            }
        </DialogTitle>
    );
};

ModaTitle.propTypes = {

};

export default ModaTitle;